module.exports = __webpack_public_path__ + "static/media/busey_profile.2c461a14.jpg";